import React from 'react';

/**
 * 쪽수처럼 짧은 수를 넣는 입력칸.
 *
 * 여기저기 흩어져 있던 숫자 입력의 규칙을 한곳에 모은다.
 * - 모바일에서 숫자 자판이 바로 뜨도록 inputMode 를 붙인다
 * - 목록을 굴리다 칸 위를 지나가면 값이 바뀌던 것을 막는다.
 *   type=number 는 휠에 반응하는데, 스크롤 중에 쪽수가 조용히 바뀌면 알아채기 어렵다
 * - 크기와 증감 화살표 처리는 .field-num 이 맡는다
 */
const NumberInput = React.forwardRef(({ className = '', ...props }, ref) => (
  <input
    ref={ref}
    type="number"
    inputMode="numeric"
    onWheel={event => event.currentTarget.blur()}
    className={`field field-num ${className}`}
    {...props}
  />
));

NumberInput.displayName = 'NumberInput';

export default NumberInput;
